import { withCompController } from '@wix/editor-elements-integrations';
import { isExperimentOpen } from '@wix/editor-elements-common-utils';
import type {
  IHeaderSectionProps,
  IHeaderSectionStateValues,
} from '../HeaderSection.types';
import { sectionExperiments } from '../../common/constants';

export default withCompController<
  IHeaderSectionProps,
  IHeaderSectionProps,
  IHeaderSectionProps,
  IHeaderSectionStateValues
>(({ mapperProps, stateValues }) => {
  const { experiments = {} } = stateValues;
  const isHeaderSectionAddVisibilityTransitionEnabled = isExperimentOpen(
    experiments,
    sectionExperiments.headerSectionAddVisibilityTransition,
  );

  return {
    ...mapperProps,
    isHeaderSectionAddVisibilityTransitionEnabled,
  };
});
